import { render, staticRenderFns } from "./attachForm.vue?vue&type=template&id=290005b5&scoped=true&"
import script from "./attachForm.vue?vue&type=script&lang=js&"
export * from "./attachForm.vue?vue&type=script&lang=js&"
import style0 from "./attachForm.vue?vue&type=style&index=0&id=290005b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290005b5",
  null
  
)

export default component.exports